
<template>
<div>
    <p>
    <span style=";font-family:宋体;font-size:14px">我们深知个人信息对您的重要性，并尽力采取相应的安全措施保护您的个人信息安全可控。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">因此，我们制定本《隐私保护服务协议》，并提示您：您在使用本应用提供的各项服务之前，应仔细阅读并透彻理解本协议，特别是以粗体</span>/<span style="font-family:宋体">粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。 您在注册程序过程中点击“同意条款，立即注册”按钮即表示您完全接受本协议的全部条款。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">一、定义</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">1.<span style="font-family:宋体">平台服务提供者：指研发“薪必果”</span><span style="font-family:Calibri">APP</span><span style="font-family:宋体">（以下简称“本应用”）并提供服务的法律主体，为汉唐融科（北京）科技有限公司。以下简称“我们”、“本公司”。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.<span style="font-family:宋体">平台用户：指在本应用注册并使用本平台服务的组织或个人，以下简称“用户”、“您”。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3.<span style="font-family:宋体">个人隐私信息是指涉及用户个人身份或个人隐私的信息，比如，用户真实姓名、身份证号、手机号码、手机设备识别码、</span><span style="font-family:Calibri">IP</span><span style="font-family:宋体">地址、用户聊天记录。非个人隐私信息是指用户对本服务的操作状态以及使用习惯等明确且客观反映在本应用服务器端的基本记录信息、个人隐私信息范围外的其它普通信息，以及用户同意公开的上述隐私信息。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">二、本协议的适用范围</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">本协议适用于薪必果</span>APP<span style="font-family:宋体">提供的所有服务，您使用本应用时，本协议即适用，无论服务项是否另行规定了隐私条款。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">三、我们如何收集并使用、共享、公开披露您的个人信息</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">（一）信息的收集</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">1. <span style="font-family:宋体">为注册成为本应用用户，以便我们为您提供服务，需要收集您的手机号以注册并创建账号，否则您将不能使用本应用项下服务。注册成为本应用用户后，您须进一步提供姓名、身份证号、身份证照片、营业执照照片、银行卡号等基本信息，并在使用特定服务时通过人脸识别以进行实人认证。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2. <span style="font-family:宋体">我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息，以保证应用的正常使用及服务的开展，包括通讯录权限，位置权限，系统相册权限，上传照片权限。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">（二）信息的使用与披露</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">1. &nbsp;<span style="font-family:宋体">尊重用户个人隐私信息的私有性是本应用的一贯制度，本应用将采取技术措施和其他必要措施，确保用户个人隐私信息安全，防止在本服务中收集的用户个人隐私信息泄露、毁损或丢失。在发生前述情形或者本应用发现存在发生前述情形的可能时，将及时采取补救措施。 本应用未经用户同意不向任何第三方公开、 透露用户个人隐私信息。但以下特定情形除外：</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;(1) <span style="font-family:宋体">本应用根据法律法规规定或有权机关的指示提供用户的个人隐私信息；</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;(2) <span style="font-family:宋体">由于用户将其用户密码告知他人或与他人共享注册帐户与密码，由此导致的任何个人信息的泄漏，或其他非因本应用原因导致的个人隐私信息的泄露；</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;(3) <span style="font-family:宋体">用户自行向第三方公开其个人隐私信息；</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;(4) <span style="font-family:宋体">用户与本应用及合作单位之间就用户个人隐私信息的使用公开达成约定，本应用因此向合作单位公开用户个人隐私信息；</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;(5) <span style="font-family:宋体">任何由于黑客攻击、电脑病毒侵入及其他不可抗力事件导致用户个人隐私信息的泄露。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2. <span style="font-family:宋体">用户同意本应用可在以下事项中使用用户的个人隐私信息：</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;(1) <span style="font-family:宋体">本应用向用户及时发送重要通知，如软件更新、本协议条款的变更；</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;(2) <span style="font-family:宋体">本应用内部进行审计、数据分析和研究等，以改进本应用的产品、服务和与用户之间的沟通；</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;(3) <span style="font-family:宋体">依本协议约定，本应用管理、审查用户信息及进行处理措施；</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;(4) <span style="font-family:宋体">适用法律法规规定的其他事项。 除上述事项外，如未取得用户事先同意，本应用不会将用户个人隐私信息使用于任何其他用途。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3. &nbsp;<span style="font-family:宋体">为了改善本应用的技术和服务，向用户提供更好的服务体验，本应用或可会自行收集使用或向第三方提供用户的非个人隐私信息。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">4.<span style="font-family:宋体">如果我们确定您出现违反法律法规或严重违反本服务项下的协议内容的情况，或为保护本服务提供者及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或相关协议规则披露关于您的个人信息。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">四、我们如何存储及保护您的个人信息</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">（一）信息存储</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">本应用收集的有关您的信息和资料将保存在本应用及（或）其关联公司的服务器上，这些信息和资料全部储存在中国境内。目前，本应用的产品和服务不会涉及到数据的跨境传输，如果我们的产品</span>/<span style="font-family:宋体">服务发生变更，涉及数据的跨境传输，我们会单独向您以弹窗或邮件的方式告知您数据出境的目的、接收方等，并征得您的授权同意，我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">我们仅在您使用我们的服务期间和法律法规要求的最短时限内保留您的个人信息，在仅浏览功能下所收集的个人信息如浏览记录，我们的存储期限不会超过</span>1<span style="font-family:宋体">年。对于超出期限的个人信息，我们会立即删除或做匿名化处理。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">（二）信息保护</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">为保障您的信息安全，我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于</span>SSL<span style="font-family:宋体">、信息加密存储、数据中心的访问控制。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">1. <span style="font-family:宋体">数据加密：我们对于用户的用户名、手机号、注册邮箱、</span><span style="font-family:Calibri">qq</span><span style="font-family:宋体">号进行加密存储，保证用户基本信息不会被恶意获取；</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2. <span style="font-family:宋体">身份鉴别：我们通过校验账号密码或者账号绑定手机验证码，进行用户身份合法性鉴别，防止非经授权的介入；</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3. <span style="font-family:宋体">访问控制：我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。用户在进行身份鉴别后，才能查询并管理用户信息和资源，未经过身份鉴别，不能管理用户资源；</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">4. <span style="font-family:宋体">安全审计：我们有时会接入风控平台或认证平台，对一些场景或行为进行监测。如通过流量分析，完成账号异常登陆、注册等异常行为的监控。 我们会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我们将尽力做到使您的信息不被泄漏、毁损或丢失。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">5. <span style="font-family:宋体">账号保护：您的账户均有安全保护功能，请妥善保管您的账户及密码信息。我们将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解，由于技术的限制以及可能存在的各种恶意手段，即便竭尽所能加强安全措施，在信息网络上也不存在“完善的安全措施”。如因您自己的原因导致账户及密码信息泄露而造成的任何法律后果需由您本人负责。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">在使用本应用平台服务进行网上交易时，如您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息（例如联系人、联络方式等），请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息已经被泄露或者存在被泄露的可能，且有可能会危及您注册获得的兼客兼职账户安全，或者给您造成其他的损失的，请您务必在第一时间根据本隐私协议提到的联系方式与我们取得联系，以便我们采取相应措施维护您的账户安全，防止损失的发生或者进一步扩大。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">6. &nbsp;<span style="font-family:宋体">互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">五、免责声明</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">互联网是一个开放平台，用户将照片等个人资料上传到互联网上，有可能会被其他组织或个人复制、转载、擅改或做其它非法用途，用户必须充分意识此类风险的存在。请您使用复杂密码，并在提供信息时采取保密措施，协助我们保证您的账号安全。我们将尽力保障您提供给我们的任何信息的安全性。对于因不可抗力或本应用无法控制的原因造成信息被非授权访问、公开披露、篡改或毁坏，本应用不承担任何责任。另外，我们不对用户所发布信息的删除或储存失败承担责任。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">六、如何联系我们</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">如果您对本协议有任何疑问、意见或建议，或者您有个人信息相关的申诉或举报，可通过客服热线</span>400-915-5380<span style="font-family:宋体">（</span><span style="font-family:Calibri">5*8</span><span style="font-family:宋体">小时，</span><span style="font-family:Calibri">9:00-18:00</span><span style="font-family:宋体">）或者投诉邮箱</span><span style="font-family:Calibri">kefu@rongketech.com</span><span style="font-family:宋体">联系我们，我们将第一时间回复您。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">七、附则</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">1. &nbsp;<span style="font-family:宋体">本用户条款的订立、执行和解释及争议的解决均应适用中华人民共和国法律。 如用户就本协议内容或其执行发生任何争议，用户应尽量与我们友好协商解决；协商不成时，任何一方均可向本平台服务提供者所在地的人民法院提起诉讼。我们未行使或执行本服务协议任何权利或规定，不构成对前述权利或权利之放弃。如本用户条款中的任何条款无论因何种原因完全或部分无效或不具有执行力，本用户条款的其余条款仍应有效并且有约束力。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2. <span style="font-family:宋体">本平台服务提供者会不定期更新本协议。如发生变更，我们将以公示的方式通知本应用所有用户，该变更将在公示期满后即时生效。若您在本本协议变更后继续使用本应用提供的任一服务，即表示您已充分阅读、理解并接受修改后的本协议并受之约束。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3. <span style="font-family:宋体">本协议所有条款的最终解释权属于本平台服务提供者。</span></span>
</p>
<p>
    <span style=";font-family:Calibri;font-size:14px">&nbsp;</span>
</p>
<p>
    <br/>
</p>
</div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/privacyAgreement.vue